/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDetailPayments_user$ref = any;
export type PdpSharedDetailPayments_user = {
    readonly isVip: boolean | null;
    readonly isVerifiedTrade: boolean | null;
    readonly canSeeNetPrice: boolean | null;
    readonly canCheckoutWithCheck: boolean | null;
    readonly " $refType": PdpSharedDetailPayments_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDetailPayments_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVip",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": "canSeeNetPrice",
            "name": "hasPermission",
            "args": [
                {
                    "kind": "Literal",
                    "name": "name",
                    "value": "B_NET_PRICE"
                }
            ],
            "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
        },
        {
            "kind": "ScalarField",
            "alias": "canCheckoutWithCheck",
            "name": "hasPermission",
            "args": [
                {
                    "kind": "Literal",
                    "name": "name",
                    "value": "B_CHECKOUT_CHECK"
                }
            ],
            "storageKey": "hasPermission(name:\"B_CHECKOUT_CHECK\")"
        }
    ]
} as any);
(node as any).hash = 'd476704e4d4c4ef0341516d97a2bafc8';
export default node;
